import React, { useState, useCallback, useRef, useEffect } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import { province } from "../../assets/geoJson/provinceData";
import bbox from "@turf/bbox";
import mapboxgl from "mapbox-gl";
import { getDistrictData, getMapData } from "./utils/index";
import styles from "./MapBox.module.css";

import {
  Layer,
  Map,
  Source,
  Marker,
  NavigationControl,
  FullscreenControl,
  ScaleControl,
  GeolocateControl,
} from "react-map-gl";

import { withRouter } from "react-router-dom";

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

export const dataLayer = {
  id: "data",
  type: "fill",
  paint: {
    "fill-color": {
      property: "id",
      type: "categorical",
      stops: [["#", "lightblue"]],
    },

    "fill-opacity": 0.5,
    "fill-outline-color": "white",
  },
  layout: {
    visibility: "visible",
  },
};

export const globalState = {
  type: "FeatureCollection",
  features: [{}],
};
const province_data = [
  "koshi",
  "madhesh",
  "bagmati",
  "gandaki",
  "lumbini",
  "karnali",
  "Sudurpashchim",
];
function MapBox({ ...props }) {
  const { provinceId, districtId, palikaId, value } = { ...props };
  const [mapData, setMapData] = useState(province);
  const [layer, setLayer] = useState(dataLayer);
  const [hoverInfo, setHoverInfo] = useState(null);
  const [selected, setSelected] = useState({ type: "nepal" });
  const [selectedProvince, setSelectedProvince] = useState(0);

  React.useEffect(() => {
    setSelectedProvince(provinceId);
    if (provinceId > 0) {
      setSelected({
        ...selected,
        type: "province",
        currentSelected: provinceId,
        label: "",
        selected: provinceId,
      });
    }
  }, [provinceId]);

  const mapRef = useRef();

  const onHover = useCallback((event) => {
    const {
      features,
      point: { x, y },
    } = event;
    const hoveredFeature = features && features[0];

    layer &&
      setLayer({
        ...layer,
        paint: {
          "fill-color": {
            property: "id",
            type: "categorical",
            stops: [
              [hoveredFeature && hoveredFeature.properties.id, "#2687a2"],
            ],
          },
          "fill-opacity": 0.5,
          "fill-outline-color": "white",
        },
      });
    // prettier-ignore
    if (hoveredFeature) {

      setHoverInfo({ ...hoverInfo, feature: hoveredFeature, x, y });
    }
  }, []);

  const handleMapClick = (event) => {
    const { features } = event;

    var bounds = new mapboxgl.LngLatBounds();
    const feature = features && features[0];
    const provinceId = feature && feature.properties.id.toString();

    if (selected.type === "nepal"&&provinceId) {
      sessionStorage.setItem("provinceId", provinceId);
      props.history.push(
        `${province_data[sessionStorage.getItem("provinceId") - 1]}`
      );
    }
  };
  console.log(
    "test provence",
    province_data[sessionStorage.getItem("provinceId") - 1]
  );
  useEffect(() => {
    let colors;
    switch (selected.type) {
      case "nepal":
        setMapData(province);
        if (mapRef && mapRef.current) {
          const [minLng, minLat, maxLng, maxLat] = bbox(province);

          mapRef.current.fitBounds(
            [
              [minLng, minLat],
              [maxLng, maxLat],
            ],
            { padding: 40, duration: 1000 }
          );
        }
        break;
      default:
        setMapData(province);
        break;
    }
  }, [selected]);

  return (
    <Map
      ref={mapRef}
      initialViewState={{
        longitude: 83.9158264002,
        latitude: 28.2489136496,
        zoom: 5.6,
      }}
      style={{ width: "100%", height: 400, color: "black" }}
      // mapStyle="mapbox://styles/mapbox/streets-v9"
      mapboxAccessToken={
        "pk.eyJ1IjoicmVnbWlzYW5pc2giLCJhIjoiY2t6OHVkYjYwMWZrdDJ4cHJrb2s2bTd4eSJ9.Pd6nVXZ9leNw48Y89czfBw"
      }
      interactiveLayerIds={["data"]}
      onMouseMove={onHover}
      attributionControl={false}
      scrollZoom={false}
      doubleClickZoom={true}
      // style={{ width: "100% ", height: "100%" }}
      onClick={handleMapClick}
    >
      <GeolocateControl position="top-left" />
      <FullscreenControl position="top-left" />
      <NavigationControl position="top-left" />
      <ScaleControl />
      <Source id="my-data" type="geojson" data={mapData}>
        <Layer {...layer} />
      </Source>

      {selected.type === "nepal" &&
        getMapData().map((x) => (
          <Marker
            key={x.id}
            longitude={(x.minLongitude + x.maxLongitude) / 2}
            latitude={(x.minLatitude + x.maxLatitude) / 2}
          >
            <label className={styles.label}>{x.label}</label>
          </Marker>
        ))}

      {(selected.type === "province" || selected.type === "district") &&
        getDistrictData(mapData).map((x) => (
          <Marker
            key={x.id}
            longitude={(x.minLongitude + x.maxLongitude) / 2}
            latitude={(x.minLatitude + x.maxLatitude) / 2}
          >
            {<p className={styles.label}>{x.label}</p>}
          </Marker>
        ))}
    </Map>
  );
}
export default withRouter(MapBox);
